var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPermissionDenied(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2641,
    height: 2080,
    viewBox: "0 0 2641 2080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M293.045 1138.72C293.045 1138.72 305.315 1438.28 622.822 1637.94C940.328 1837.61 1380.3 1851.9 1736.48 1870.87C2092.65 1889.83 2366.23 1731.03 2407.46 1490.99C2448.69 1250.94 2176.53 1180.47 2028.86 907.217C1881.2 633.963 1894.34 544.145 1581.89 376.081C1269.44 208.017 780.68 311.214 524.418 599.132C268.162 887.049 293.045 1138.72 293.045 1138.72Z",
    fill: "#0870B1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M293.045 1138.72C293.045 1138.72 305.315 1438.28 622.822 1637.94C940.328 1837.61 1380.3 1851.9 1736.48 1870.87C2092.65 1889.83 2366.23 1731.03 2407.46 1490.99C2448.69 1250.94 2176.53 1180.47 2028.86 907.217C1881.2 633.963 1894.34 544.145 1581.89 376.081C1269.44 208.017 780.68 311.214 524.418 599.132C268.162 887.049 293.045 1138.72 293.045 1138.72Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M441.639 747.494V640.303C441.639 564.425 521.698 502.694 620.102 502.694C718.505 502.694 798.565 564.425 798.565 640.303V747.494H869.713V640.303C869.713 534.177 757.74 447.836 620.102 447.836C482.463 447.836 370.49 534.177 370.49 640.303V747.494H441.639Z",
    stroke: "black",
    strokeWidth: 1.17,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M889.061 748.267H344.054V1103.34H889.061V748.267Z",
    stroke: "black",
    strokeWidth: 1.17,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M673.233 895.719C673.233 870.451 646.67 849.971 613.9 849.971C581.131 849.971 554.568 870.455 554.568 895.719C554.568 913.124 567.171 928.254 585.726 935.987L575.759 1016.63H652.047L642.08 935.987C660.625 928.25 673.233 913.124 673.233 895.719Z",
    stroke: "black",
    strokeWidth: 1.17,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1228.79 1114.83L1093.12 1107.8V1106.07L1076.44 1106.93L1059.76 1106.07V1107.8L924.091 1114.83L824.003 1762.95H924.091L1073.1 1246.2H1079.77L1228.79 1762.95H1328.88L1228.79 1114.83Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 1.1663,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M824.003 1762.95L799.536 1792.72L723.919 1819C723.919 1819 710.577 1824.25 710.577 1836.52C710.577 1848.78 710.577 1859.29 710.577 1859.29H926.315C926.315 1859.29 928.539 1840.02 926.315 1822.5C924.091 1804.99 924.091 1762.95 924.091 1762.95H824.003V1762.95Z",
    fill: "#4C4C4C",
    stroke: "black",
    strokeWidth: 1.1663,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M710.577 1840.02C710.577 1850.71 710.577 1859.29 710.577 1859.29H926.315C926.315 1859.29 927.287 1850.82 927.297 1840.02H710.577Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 1.1663,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1328.47 1762.95L1352.93 1792.72L1428.55 1819C1428.55 1819 1441.89 1824.25 1441.89 1836.52C1441.89 1848.78 1441.89 1859.29 1441.89 1859.29H1226.15C1226.15 1859.29 1223.93 1840.02 1226.15 1822.5C1228.38 1804.99 1228.38 1762.95 1228.38 1762.95H1328.47V1762.95Z",
    fill: "#4C4C4C",
    stroke: "black",
    strokeWidth: 1.1663,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M1441.9 1840.02C1441.9 1850.71 1441.9 1859.29 1441.9 1859.29H1226.16C1226.16 1859.29 1225.19 1850.82 1225.18 1840.02H1441.9Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 1.1663,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M866.628 813.317C866.628 813.317 708.353 988.707 708.353 1001.55C708.353 1014.4 733.559 1113.66 773.591 1123C813.623 1132.34 835.866 1115.99 843.282 1083.3C850.698 1050.6 825.487 1003.89 825.487 1003.89L899.625 951.338L866.628 813.317Z",
    fill: "#0870B1",
    stroke: "black",
    strokeWidth: 1.1663,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M835.866 1078.63C835.866 1078.63 881.83 1072.79 893.693 1075.13C905.557 1077.46 914.452 1099.65 914.452 1099.65C914.452 1099.65 918.899 1132.35 911.483 1139.35C904.067 1146.36 868.482 1154.53 853.656 1156.87C838.829 1159.2 807.692 1132.35 795.828 1116C783.97 1099.65 804.729 1071.62 835.866 1078.63Z",
    fill: "#CCCCCC",
    stroke: "black",
    strokeWidth: 1.1663,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M899.952 805.364L866.628 813.317L919.142 1089.31H1231.2L1278.67 814.911L1236.25 802.185L1079.71 775.141L899.952 805.364Z",
    fill: "#0870B1",
    stroke: "black",
    strokeWidth: 1.1663,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1248.37 897.628L1241.3 937.398L1186.77 947.74L1131.22 930.238L1135.26 894.446L1248.37 897.628Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 1.1663,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1180.71 929.843C1180.71 925.671 1185 922.289 1190.3 922.289C1195.6 922.289 1199.89 925.671 1199.89 929.843C1199.89 934.016 1195.6 937.398 1190.3 937.398C1185 937.398 1180.71 934.016 1180.71 929.843Z",
    fill: "#4C4C4C",
    stroke: "black",
    strokeWidth: 1.1663,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1046.39 826.043L1075.67 853.087L1038.31 1040.8L1077.7 1090.11L1124.15 1038.41L1084.76 853.882L1118.09 828.431L1082.75 792.638L1046.39 826.043Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 1.1663,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1018.11 779.118L883.795 805.364L887.836 818.089L1019.12 789.456L1018.11 779.118Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 1.1663,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M1128.19 775.936L1262.51 802.185L1258.47 814.911L1127.18 786.277L1128.19 775.936Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 1.1663,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M1262.51 802.185C1262.51 802.185 1313.31 811.212 1344.44 825.223C1375.58 839.238 1383 870.767 1365.2 905.798C1347.41 940.834 1292.55 936.162 1267.34 926.819C1242.14 917.476 1234.72 882.444 1239.17 867.264",
    fill: "#0870B1"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M1262.51 802.185C1262.51 802.185 1313.31 811.212 1344.44 825.223C1375.58 839.238 1383 870.767 1365.2 905.798C1347.41 940.834 1292.55 936.162 1267.34 926.819C1242.14 917.476 1234.72 882.444 1239.17 867.264",
    stroke: "black",
    strokeWidth: 1.1663,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M1024.17 765.598L1009.02 773.548L1013.06 853.882L1078.71 817.294L1147.38 854.68L1153.44 775.141L1135.26 763.21L1024.17 765.598Z",
    fill: "#0870B1",
    stroke: "black",
    strokeWidth: 1.1663,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M1156.84 670.051C1156.84 670.051 1194.13 662.904 1201.19 633.531C1208.25 604.157 1140.71 568.431 1094.34 562.078C1047.97 555.726 979.425 593.836 968.339 620.031C957.252 646.231 1000.6 672.431 1046.97 677.988C1093.33 683.546 1156.84 670.051 1156.84 670.051Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 1.1663,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M1017.73 674.814C1017.73 674.814 997.569 650.204 992.53 671.64C987.491 693.077 1008.66 702.603 1017.73 701.809C1026.8 701.014 1017.73 674.814 1017.73 674.814Z",
    fill: "#CCCCCC",
    stroke: "black",
    strokeWidth: 1.1663,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M1148.78 674.814C1148.78 674.814 1168.94 650.204 1173.98 671.64C1179.02 693.077 1157.85 702.603 1148.78 701.809C1139.7 701.014 1148.78 674.814 1148.78 674.814Z",
    fill: "#CCCCCC",
    stroke: "black",
    strokeWidth: 1.1663,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M1022.15 723.441V775.936L1078.71 817.294L1142.33 774.347V725.03L1022.15 723.441Z",
    fill: "#CCCCCC",
    stroke: "black",
    strokeWidth: 1.1663,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M1013.7 658.936C1013.7 658.936 1010.67 708.157 1015.72 724.035C1020.76 739.914 1054.02 773.257 1080.23 780.404C1106.44 787.55 1142.73 744.677 1150.79 730.388C1158.86 716.098 1155.83 655.762 1155.83 655.762C1155.83 655.762 1144.75 635.12 1122.57 628.767C1100.39 622.419 1031.84 611.304 1013.7 658.936Z",
    fill: "#CCCCCC",
    stroke: "black",
    strokeWidth: 1.1663,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M1055.63 685.069C1055.63 688.821 1053.45 691.858 1050.76 691.858C1048.07 691.858 1045.88 688.817 1045.88 685.069C1045.88 681.321 1048.07 678.28 1050.76 678.28C1053.45 678.28 1055.63 681.316 1055.63 685.069Z",
    fill: "black"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M1117.49 685.069C1117.49 688.821 1115.3 691.858 1112.61 691.858C1109.92 691.858 1107.74 688.817 1107.74 685.069C1107.74 681.321 1109.92 678.28 1112.61 678.28C1115.3 678.28 1117.49 681.316 1117.49 685.069Z",
    fill: "black"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M1066.14 704.038C1061.6 704.038 1057.92 706.36 1057.92 709.222C1057.92 712.084 1061.6 714.405 1066.14 714.405C1068.43 714.405 1070.5 713.814 1071.99 712.862C1074.6 715.653 1079.36 717.546 1084.88 717.546C1090.17 717.546 1094.8 715.807 1097.47 713.195C1098.89 713.939 1100.69 714.405 1102.69 714.405C1107.23 714.405 1110.92 712.084 1110.92 709.222C1110.92 706.36 1107.23 704.038 1102.69 704.038",
    fill: "#CCCCCC"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M1066.14 704.038C1061.6 704.038 1057.92 706.36 1057.92 709.222C1057.92 712.084 1061.6 714.405 1066.14 714.405C1068.43 714.405 1070.5 713.814 1071.99 712.862C1074.6 715.653 1079.36 717.546 1084.88 717.546C1090.17 717.546 1094.8 715.807 1097.47 713.195C1098.89 713.939 1100.69 714.405 1102.69 714.405C1107.23 714.405 1110.92 712.084 1110.92 709.222C1110.92 706.36 1107.23 704.038 1102.69 704.038",
    stroke: "black",
    strokeWidth: 1.1663,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M1074.17 736.624H1095.23",
    stroke: "black",
    strokeWidth: 1.1663,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M1011.4 670.896C1011.4 670.896 1012.15 686.837 1018.89 682.706C1025.64 678.571 1027.89 651.41 1021.89 647.87C1015.9 644.326 1011.4 662.63 1011.4 670.896Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 1.1663,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M1141.51 670.896C1141.51 670.896 1142.26 686.837 1149.01 682.706C1155.75 678.571 1158 651.41 1152.01 647.87C1146.01 644.326 1141.51 662.63 1141.51 670.896Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 1.1663,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M1011.4 657.908C1011.4 657.908 1013.67 659.343 1013.63 660.059C1023.39 664.227 1045.85 671.886 1082.18 673.433C1113.37 674.76 1140.1 666.028 1155.97 659.177C1155.89 657.035 1155.83 655.774 1155.83 655.766C1154.91 637.15 1137.37 624.774 1115.64 620.011C1094.88 615.455 1071.04 616.229 1050.99 622.548C1040.62 625.818 1031.18 630.752 1024.25 637.724C1021.95 640.037 1007.72 655.583 1011.4 657.908Z",
    fill: "#4C4C4C",
    stroke: "black",
    strokeWidth: 1.1663,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M1013.7 658.936C1013.7 658.936 1038.9 664.493 1082.24 662.904C1125.59 661.315 1155.76 658.94 1155.76 658.94C1155.76 658.94 1126.21 682.573 1082.86 684.162C1036.01 685.876 1013.7 658.936 1013.7 658.936Z",
    fill: "#4C4C4C",
    stroke: "black",
    strokeWidth: 1.1663,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M902.984 897.628L910.052 937.398L964.588 947.74L1020.13 930.238L1016.09 894.446L902.984 897.628Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 1.1663,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M970.647 929.843C970.647 925.671 966.352 922.289 961.055 922.289C955.757 922.289 951.462 925.671 951.462 929.843C951.462 934.016 955.757 937.398 961.055 937.398C966.352 937.398 970.647 934.016 970.647 929.843Z",
    fill: "#4C4C4C",
    stroke: "black",
    strokeWidth: 1.1663,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M1234.72 1086.8H914.452V1126.51H1234.72V1086.8Z",
    fill: "#4C4C4C",
    stroke: "black",
    strokeWidth: 1.1663,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M975.987 1138.18H906.296C898.516 1138.18 892.209 1133.22 892.209 1127.09V1100.23C892.209 1094.1 898.516 1089.13 906.296 1089.13H975.987C983.767 1089.13 990.074 1094.1 990.074 1100.23V1127.09C990.069 1133.22 983.762 1138.18 975.987 1138.18Z",
    fill: "#4C4C4C",
    stroke: "black",
    strokeWidth: 1.1663,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M1231.02 1138.18H1161.33C1153.55 1138.18 1147.24 1133.22 1147.24 1127.09V1100.23C1147.24 1094.1 1153.55 1089.13 1161.33 1089.13H1231.02C1238.8 1089.13 1245.1 1094.1 1245.1 1100.23V1127.09C1245.1 1133.22 1238.79 1138.18 1231.02 1138.18Z",
    fill: "#4C4C4C",
    stroke: "black",
    strokeWidth: 1.1663,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M1114.62 1089.14H1044.93V1124.17H1114.62V1089.14Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.1663,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M825.487 1003.89C825.487 1003.89 781.002 1001.55 764.696 979.368",
    stroke: "black",
    strokeWidth: 1.1663,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M1319.98 901.127C1360.51 901.127 1393.37 873.94 1393.37 840.403C1393.37 806.867 1360.51 779.68 1319.98 779.68C1279.44 779.68 1246.58 806.867 1246.58 840.403C1246.58 873.94 1279.44 901.127 1319.98 901.127Z",
    fill: "#0870B1",
    stroke: "black",
    strokeWidth: 1.1663,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M1319.98 850.204C1351.72 850.204 1377.45 832.047 1377.45 809.648C1377.45 787.25 1351.72 769.093 1319.98 769.093C1288.24 769.093 1262.51 787.25 1262.51 809.648C1262.51 832.047 1288.24 850.204 1319.98 850.204Z",
    fill: "#0870B1",
    stroke: "black",
    strokeWidth: 1.1663,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M1319.98 820.381C1351.72 820.381 1377.45 802.224 1377.45 779.825C1377.45 757.427 1351.72 739.269 1319.98 739.269C1288.24 739.269 1262.51 757.427 1262.51 779.825C1262.51 802.224 1288.24 820.381 1319.98 820.381Z",
    fill: "#CCCCCC",
    stroke: "black",
    strokeWidth: 1.1663,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M1227.65 692.378C1227.65 692.378 1228.62 752.207 1232.52 769.85C1236.42 787.492 1252 810.501 1273.43 810.501C1294.85 810.501 1315.3 804.365 1315.3 804.365C1315.3 804.365 1340.62 815.102 1364.97 812.036C1389.32 808.966 1385.43 782.122 1385.43 770.615C1385.43 759.109 1382.51 672.435 1382.51 672.435C1382.51 672.435 1384.45 663.998 1374.71 662.463C1364.97 660.928 1360.1 660.928 1360.1 660.928V642.52C1360.1 642.52 1356.21 636.384 1343.55 636.384C1330.88 636.384 1329.91 638.685 1329.91 638.685V621.812C1329.91 621.812 1319.39 608.375 1305.56 614.91C1295.82 619.511 1295.82 627.182 1295.82 627.182L1294.85 643.29C1294.85 643.29 1271.48 636.384 1269.53 647.125C1267.58 657.862 1263.69 723.832 1263.69 723.832C1263.69 723.832 1260.77 703.119 1255.9 693.152C1251.03 683.172 1227.65 683.172 1227.65 692.378Z",
    fill: "#CCCCCC",
    stroke: "black",
    strokeWidth: 1.1663,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M1294.86 643.286L1296.8 713.856",
    stroke: "black",
    strokeWidth: 1.1663,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M1329.92 638.685L1330.89 714.621",
    stroke: "black",
    strokeWidth: 1.1663,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M1360.11 660.928L1358.16 713.856",
    stroke: "black",
    strokeWidth: 1.1663,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M1282.19 713.086L1370.82 716.156",
    stroke: "black",
    strokeWidth: 1.1663,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M1263.69 723.827C1263.69 723.827 1263.6 734.02 1273.22 738.754C1282.84 743.488 1304.49 755.801 1306.89 775.694",
    stroke: "black",
    strokeWidth: 1.1663,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M1848.59 535.866V544.939H1820.46V577.208H1855.01V586.406H1807.63V495.693H1855.01V504.891H1820.46V535.862L1848.59 535.866Z",
    fill: "black"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M1892.52 495.693C1910.62 495.693 1918.2 502.952 1918.2 516.431V523.815C1918.2 533.795 1913.75 540.014 1903.88 542.476C1914.41 544.939 1918.35 551.683 1918.35 561.396V575.524C1918.35 579.538 1918.52 583.299 1920.66 586.406H1907.65C1906.18 583.814 1905.52 581.481 1905.52 575.39V561.138C1905.52 550.896 1899.42 547.66 1888.73 547.66H1879.68V586.406H1866.85V495.693H1892.52ZM1889.23 538.462C1899.43 538.462 1905.52 535.866 1905.52 526.02V517.338C1905.52 509.176 1901.74 504.895 1892.2 504.895H1879.68V538.462H1889.23Z",
    fill: "black"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M1957.36 495.693C1975.45 495.693 1983.03 502.952 1983.03 516.431V523.815C1983.03 533.795 1978.58 540.014 1968.71 542.476C1979.24 544.939 1983.19 551.683 1983.19 561.396V575.524C1983.19 579.538 1983.35 583.299 1985.49 586.406H1972.49C1971.02 583.814 1970.36 581.481 1970.36 575.39V561.138C1970.36 550.896 1964.26 547.66 1953.56 547.66H1944.52V586.406H1931.69V495.693H1957.36ZM1954.07 538.462C1964.26 538.462 1970.36 535.866 1970.36 526.02V517.338C1970.36 509.176 1966.57 504.895 1957.03 504.895H1944.52V538.462H1954.07Z",
    fill: "black"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M1995.52 517.591C1995.52 503.73 2004.25 494.79 2021.85 494.79C2039.62 494.79 2048.34 503.734 2048.34 517.591V564.508C2048.34 578.244 2039.62 587.313 2021.85 587.313C2004.25 587.313 1995.52 578.244 1995.52 564.508V517.591ZM2008.2 565.028C2008.2 573.323 2012.64 578.115 2021.85 578.115C2031.23 578.115 2035.51 573.323 2035.51 565.028V517.076C2035.51 508.914 2031.23 503.988 2021.85 503.988C2012.64 503.988 2008.2 508.914 2008.2 517.076V565.028Z",
    fill: "black"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M2086.18 495.693C2104.27 495.693 2111.85 502.952 2111.85 516.431V523.815C2111.85 533.795 2107.41 540.014 2097.53 542.476C2108.06 544.939 2112.01 551.683 2112.01 561.396V575.524C2112.01 579.538 2112.17 583.299 2114.32 586.406H2101.31C2099.84 583.814 2099.18 581.481 2099.18 575.39V561.138C2099.18 550.896 2093.08 547.66 2082.39 547.66H2073.34V586.406H2060.51V495.693H2086.18ZM2082.89 538.462C2093.09 538.462 2099.18 535.866 2099.18 526.02V517.338C2099.18 509.176 2095.4 504.895 2085.86 504.895H2073.34V538.462H2082.89Z",
    fill: "black"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M1739.76 1101.91V1111.11H1713.27V1150.38H1700.44V1059.66H1746.18V1068.86H1713.27V1101.91H1739.76Z",
    fill: "black"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M1755.39 1081.56C1755.39 1067.7 1764.11 1058.76 1781.72 1058.76C1799.48 1058.76 1808.21 1067.7 1808.21 1081.56V1128.48C1808.21 1142.22 1799.48 1151.28 1781.72 1151.28C1764.11 1151.28 1755.39 1142.22 1755.39 1128.48V1081.56ZM1768.06 1128.99C1768.06 1137.29 1772.5 1142.08 1781.72 1142.08C1791.09 1142.08 1795.37 1137.29 1795.37 1128.99V1081.04C1795.37 1072.88 1791.09 1067.96 1781.72 1067.96C1772.5 1067.96 1768.06 1072.88 1768.06 1081.04V1128.99Z",
    fill: "black"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M1846.05 1059.66C1864.15 1059.66 1871.72 1066.92 1871.72 1080.4V1087.79C1871.72 1097.77 1867.28 1103.98 1857.41 1106.44C1867.94 1108.91 1871.89 1115.65 1871.89 1125.36V1139.49C1871.89 1143.5 1872.05 1147.27 1874.2 1150.37H1861.2C1859.72 1147.78 1859.06 1145.45 1859.06 1139.36V1125.11C1859.06 1114.86 1852.97 1111.63 1842.27 1111.63H1833.22V1150.37H1820.39V1059.66H1846.05V1059.66ZM1842.76 1102.43C1852.96 1102.43 1859.05 1099.83 1859.05 1089.99V1081.3C1859.05 1073.14 1855.27 1068.86 1845.73 1068.86H1833.21V1102.43H1842.76Z",
    fill: "black"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M1911.04 1059.66C1928.98 1059.66 1936.05 1066.4 1936.05 1079.75V1084.03C1936.05 1093.62 1932.59 1099.58 1922.55 1102.04C1933.74 1104.5 1938.02 1111.5 1938.02 1121.48V1129.12C1938.02 1142.74 1929.63 1150.38 1911.69 1150.38H1885.2V1059.66H1911.04ZM1907.91 1098.15C1918.12 1098.15 1923.38 1095.56 1923.38 1086.1V1080.78C1923.38 1072.75 1919.92 1068.86 1910.71 1068.86H1898.03V1098.14H1907.91V1098.15ZM1911.7 1141.18C1921.08 1141.18 1925.35 1137.29 1925.35 1128.87V1120.83C1925.35 1110.72 1920.26 1107.35 1909.23 1107.35H1898.04V1141.18H1911.7Z",
    fill: "black"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M1962.54 1059.66V1150.38H1949.71V1059.66H1962.54Z",
    fill: "black"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M2002.69 1059.66C2020.62 1059.66 2028.85 1068.22 2028.85 1082.21V1127.96C2028.85 1141.82 2020.62 1150.38 2002.69 1150.38H1975.71V1059.66H2002.69ZM2002.52 1141.18C2011.74 1141.18 2016.18 1136.64 2016.18 1128.35V1081.7C2016.18 1073.4 2011.73 1068.87 2002.36 1068.87H1988.54V1141.18H2002.52V1141.18Z",
    fill: "black"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M2067.84 1059.66C2085.78 1059.66 2094 1068.22 2094 1082.21V1127.96C2094 1141.82 2085.78 1150.38 2067.84 1150.38H2040.86V1059.66H2067.84ZM2067.67 1141.18C2076.89 1141.18 2081.33 1136.64 2081.33 1128.35V1081.7C2081.33 1073.4 2076.89 1068.87 2067.51 1068.87H2053.68V1141.18H2067.67V1141.18Z",
    fill: "black"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M2146.98 1099.83V1108.91H2118.84V1141.18H2153.4V1150.37H2106.01V1059.66H2153.4V1068.86H2118.84V1099.83H2146.98V1099.83Z",
    fill: "black"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M2176.6 1150.38H2165.09V1059.66H2181.38L2208.03 1125.23V1059.66H2219.39V1150.38H2206.05L2176.6 1077.03V1150.38H2176.6Z",
    fill: "black"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M1619.17 866.345L1736.66 647.496H1807.16V866.345H1837.71V912.613H1807.16V971.377H1743.72V912.613H1619.18L1619.17 866.345ZM1743.71 866.345V744.661L1678.5 866.345H1743.71Z",
    fill: "black"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M1861.79 725.229C1861.79 673.412 1896.45 643.802 1959.9 643.802C2023.34 643.802 2058.01 673.412 2058.01 725.229V893.647C2058.01 945.464 2023.34 975.075 1959.9 975.075C1896.45 975.075 1861.79 945.464 1861.79 893.647V725.229ZM1926.41 896.888C1926.41 920.022 1939.34 928.812 1959.9 928.812C1980.46 928.812 1993.39 920.022 1993.39 896.888V721.993C1993.39 698.859 1980.46 690.069 1959.9 690.069C1939.34 690.069 1926.41 698.859 1926.41 721.993V896.888Z",
    fill: "black"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M2224.27 727.085C2224.27 697.936 2211.34 690.069 2190.78 690.069C2170.22 690.069 2157.29 698.859 2157.29 721.993V742.814H2096.19V725.229C2096.19 673.412 2129.08 643.802 2192.54 643.802C2255.98 643.802 2288.88 673.412 2288.88 725.229V733.558C2288.88 768.265 2274.78 790.009 2243.64 800.184C2275.96 811.292 2288.88 835.345 2288.88 868.196V893.647C2288.88 945.464 2255.98 975.075 2192.54 975.075C2129.08 975.075 2096.19 945.464 2096.19 893.647V866.807H2157.29V896.884C2157.29 920.017 2170.22 928.807 2190.78 928.807C2211.34 928.807 2224.27 920.941 2224.27 892.258V866.807C2224.27 836.734 2211.34 825.627 2181.97 825.627H2160.23V779.359H2185.49C2209.58 779.359 2224.26 771.031 2224.26 745.118V727.085H2224.27Z",
    fill: "black"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M458.853 1857.46H383.547L483.953 1306.18H559.258L458.853 1857.46Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 1.1663,
    strokeMiterlimit: 10
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M609.464 1857.46H684.764L584.358 1306.18H509.058L609.464 1857.46Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.1663,
    strokeMiterlimit: 10
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M1527.46 1857.46H1452.15L1552.56 1306.18H1627.86L1527.46 1857.46Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 1.1663,
    strokeMiterlimit: 10
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M1678.06 1857.46H1753.37L1652.96 1306.18H1577.66L1678.06 1857.46Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.1663,
    strokeMiterlimit: 10
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M1730.71 1219.75H294.387V1329.42H1730.71V1219.75Z",
    fill: "#0870B1",
    stroke: "black",
    strokeWidth: 1.1663,
    strokeMiterlimit: 10
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M1765.71 1219.75H329.396V1329.42H1765.71V1219.75Z",
    fill: "#0870B1",
    stroke: "black",
    strokeWidth: 1.1663,
    strokeMiterlimit: 10
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M352.906 1329.42H474.825L537.824 1219.75H415.899L352.906 1329.42Z",
    fill: "black"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M835.454 1219.75H713.535L650.536 1329.42H772.456L835.454 1219.75Z",
    fill: "black"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M1728.35 1219.75H1606.43L1543.43 1329.42H1665.35L1728.35 1219.75Z",
    fill: "black"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M1430.72 1219.75H1308.8L1245.8 1329.42H1367.72L1430.72 1219.75Z",
    fill: "black"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M1133.08 1219.75H1011.16L948.167 1329.42H1070.09L1133.08 1219.75Z",
    fill: "black"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M1757.87 1268.4H1520.16",
    stroke: "black",
    strokeWidth: 1.1663,
    strokeMiterlimit: 10
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M1753.7 1286.74H1716.16",
    stroke: "black",
    strokeWidth: 1.1663,
    strokeMiterlimit: 10
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M323.306 1282.16H561.012",
    stroke: "black",
    strokeWidth: 1.1663,
    strokeMiterlimit: 10
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M327.479 1261.52H627.734",
    stroke: "black",
    strokeWidth: 1.1663,
    strokeMiterlimit: 10
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M2157.75 1833.39H1750.3V1857.46H2157.75V1833.39Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 1.1663,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M2088.99 1832.72H1819.06L1924.88 1379.45H1983.18L2088.99 1832.72Z",
    fill: "#0870B1",
    stroke: "black",
    strokeWidth: 1.1663,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M1885.55 1547.92H2022.51L2009.4 1491.76H1898.66L1885.55 1547.92Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.1663,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M2048.42 1757.08L2055.19 1788.06",
    stroke: "black",
    strokeWidth: 1.1663,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M1971.36 1404.49L2039.9 1718.06",
    stroke: "black",
    strokeWidth: 1.1663,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M2376.95 1857.46H2413.47",
    stroke: "black",
    strokeWidth: 1.1663,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M207.963 1857.46H2326",
    stroke: "black",
    strokeWidth: 1.1663,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPermissionDenied);
export default __webpack_public_path__ + "static/media/permission-denied.1cf43bdb8f56013b6214a1101df8a021.svg";
export { ForwardRef as ReactComponent };